import { useEffect, useState, type ReactNode } from 'react';
import { Link, useRouter } from '../lib/router';
import { formatUtc } from '../lib/time';
import { ThemeToggle } from './ThemeToggle';
import { useSession } from '../auth/SessionContext';
import { isMockMode } from '../dev/mode';
import { Notice } from './Async';

const NAV = [
  { to: '/overview', label: 'Áttekintés', match: (p: string) => p === '/overview' },
  { to: '/mark', label: 'Megjelölés', match: (p: string) => p === '/mark' },
  { to: '/loans', label: 'Hitelek', match: (p: string) => p === '/loans' || p.startsWith('/loans/') },
  { to: '/events', label: 'Események', match: (p: string) => p === '/events' },
  { to: '/deals', label: 'Ügyletek', match: (p: string) => p.startsWith('/deals') },
  { to: '/locations', label: 'Helyszínek', match: (p: string) => p === '/locations' },
  { to: '/entries/new', label: 'Kézi bevitel', match: (p: string) => p === '/entries/new' },
  { to: '/help', label: 'Súgó', match: (p: string) => p === '/help' },
];

function useUtcClock(): string {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(t);
  }, []);
  return formatUtc(now);
}

export function AppShell({ children }: { children: ReactNode }) {
  const { pathname } = useRouter();
  const clock = useUtcClock();
  const { state, logout, logoutError } = useSession();
  return (
    <>
      <header className="topbar">
        <div className="brand">
          <b>MoneyFlow</b>
          <span className="mono muted small">grabbitfund</span>
        </div>
        <nav className="nav" aria-label="Fő navigáció">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className={n.match(pathname) ? 'on' : undefined} aria-current={n.match(pathname) ? 'page' : undefined}>
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="topbar-right">
          {isMockMode() ? <span className="badge">Mintaadat</span> : null}
          <span className="mono muted small" data-testid="utc-clock">
            {clock} UTC
          </span>
          <ThemeToggle />
          {state.status === 'authenticated' ? (
            <button type="button" className="btn small" onClick={logout} title={state.me.email ?? state.me.sub}>
              Kilépés
            </button>
          ) : null}
        </div>
      </header>
      {logoutError ? (
        <div className="page" style={{ paddingBottom: 0 }}>
          <Notice kind="err" title="A kilépés nem sikerült">
            {logoutError} A munkamenet még él; próbáld újra.
          </Notice>
        </div>
      ) : null}
      {children}
    </>
  );
}
